import { Capacitor } from "@capacitor/core"
import { retrieveLaunchParams } from "@telegram-apps/bridge"

export type Platform = "telegram" | "android" | "ios" | "browser"
export type NativePlatform = Extract<Platform, "android" | "ios">

let cached: Platform | null = null

export function detectPlatform(): Platform {
	if (cached) return cached

	if (typeof window === "undefined") {
		cached = "browser"
		return cached
	}

	// 1. Capacitor native — проверяем первым,
	//    т.к. в Capacitor WebView Telegram SDK недоступен
	if (Capacitor.isNativePlatform()) {
		if (Capacitor.getPlatform() === "ios") {
			cached = "ios"
		}

		if (Capacitor.getPlatform() === "android") {
			cached = "android"
		}

		return cached ?? "android"
	}

	// 2. Telegram Mini App — проверяем через launch params
	try {
		retrieveLaunchParams()
		cached = "telegram"
	} catch {
		cached = "browser"
	}

	return cached
}
